module.exports = __webpack_public_path__ + "img/blankdualscreen_300.613277bb.png";